import { render, staticRenderFns } from "./verdok_ppbpemda.vue?vue&type=template&id=05befca2&scoped=true"
import script from "./verdok_ppbpemda.vue?vue&type=script&lang=js"
export * from "./verdok_ppbpemda.vue?vue&type=script&lang=js"
import style0 from "./verdok_ppbpemda.vue?vue&type=style&index=0&id=05befca2&prod&lang=scss"
import style1 from "./verdok_ppbpemda.vue?vue&type=style&index=1&id=05befca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05befca2",
  null
  
)

export default component.exports